<template>
    <div class="gallery" id="print-gallery">
        <div class="single-car-row">
            <div class="single-car-title">{{ lot.company }} {{ lot.model_name }} {{ lot.model_year_en }}</div>
        </div>
       <div class="">
            <div class="columns is-tablet theme-columns">
                <div class="content column is-two-thirds main-image-column">
                    <figure class="image-main">
                        <img :src="mainPic"  @click="openGallery(mainPicIndex)" class="main-image">
                        <div class="prev-btn" @click="slideGallery('prev')"><i class="fas fa-chevron-left"></i></div>
                        <div class="next-btn" @click="slideGallery('next')"><i class="fas fa-chevron-right"></i></div>
                    </figure>
                </div>
                <div class="center column is-one-third main-gallery-column">
                    <div class="image-box" v-for="(image, i) in images" @mouseover="setMainPic(image, i)" @click="openGallery(i)" v-bind:key="'key'+i">
                        <div class="image-thumb">
                            <img :src="image" />
                        </div>
                    </div>
                    <gallery :isOpen="isOpen" :items="items" :options="options" @close="closeGallery"></gallery>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Gallery from './../Advance/Result/Gallery'
    export default {
        props: ['lot'],
        components: {
            Gallery
        },
        data () {
            return {
                images: this.lot.pictures.split('#'),
                index: null,
                mainPic: this.lot.pictures.split('#')[1],
                mainPicIndex: 1
            }
        },
        methods: {
            setMainPic(img, index) {
                this.mainPic = img
                this.mainPicIndex = index
            },
            closeGallery() {
                this.$store.dispatch('setResultGalleryStatus', false)
            },
            openGallery(index) {
                this.$store.dispatch('setResultGalleryItems', this.lot.pictures.split('#'))
                this.$store.dispatch('setResultGalleryOptions', { index: index })
                this.$store.dispatch('setResultGalleryStatus', true)
            },
            slideGallery(slideType) {
                if(slideType == 'prev'){
                    var prevIndex = this.mainPicIndex - 1 >= 0 ? this.mainPicIndex - 1 : 0;
                    return this.setMainPic(this.lot.pictures.split('#')[prevIndex], prevIndex)
                }else{
                    var nextIndex = this.mainPicIndex + 1 < this.lot.pictures.split('#').length ? this.mainPicIndex + 1 : this.lot.pictures.split('#').length - 1;
                    return this.setMainPic(this.lot.pictures.split('#')[nextIndex], nextIndex);
                }
            }
        },
        computed: {
            items() {
                return this.$store.getters.getResultGalleryItems
            },
            options() {
                return this.$store.getters.getResultGalleryOptions
            },
            isOpen() {
                return this.$store.getters.getResultGalleryStatus
            },
        }
    }
</script>

<style scoped>
    .image-main {
        width: 100%;
        margin: 0;
        display: flex;
        align-items: flex-start;
        cursor: pointer;
        /*height: 480px;*/
        overflow: hidden;
    }
    .image-main img {
        min-width: 100%;
    }
    .image-main:hover {
        filter: brightness(95%);
    }
    .image-box {
        border: 1px solid white;
        width: 23%;
        margin: 0 1%;
        height: 70px;
        display: inline-block;
        background: lightgrey;
        overflow: hidden;
        border-radius: 4px;
    }
    .image-thumb {
        display: flex;
        height: 100%;
        align-items: center;
        cursor: pointer;
    }
    .image-thumb:hover {
        filter: brightness(95%);
    }
    @media (max-width:767px){
        .image-main {
            height: auto;
        }
        .content:not(:last-child) {
            margin-bottom: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Lot/GalleryBox.vue